<script setup lang="ts">
import { ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useI18n } from 'vue-i18n'

interface IProps {
  iconSize?: number
}

withDefaults(defineProps<IProps>(), {
  iconSize: 24,
})

const { mobile } = useDisplay()
const { t } = useI18n()
const isVisible = ref(false)
</script>

<template>
  <v-dialog
    v-model="isVisible"
    :fullscreen="mobile"
    transition="dialog-bottom-transition"
    max-width="500"
    class="blur-dialog-overlay"
  >
    <template #activator="{ props: activatorProps }">
      <slot name="activator" :props="activatorProps">
        <v-icon
          icon="ri-information-line"
          v-bind="activatorProps"
          color="primary-light"
          class="cursor-pointer"
          :size="iconSize"
        />
      </slot>
    </template>

    <v-card class="bg-surface pa-4 rounded-xl d-flex flex-column ga-4 h-100">
      <div class="d-flex align-center justify-space-between w-100 border-b pb-2">
        <span class="font-weight-bold text-subtitle-1">{{ t('leaderboardRules.title') }}</span>
        <v-icon
          icon="ri-close-line"
          class="cursor-pointer"
          size="24"
          @click="isVisible = false"
        />
      </div>

      <v-card-text class="pa-0 overflow-y-auto flex-grow-1" style="max-height: 75vh;">
        <div class="d-flex flex-column ga-3 text-body-2" style="line-height: 1.5;">
          <div class="font-weight-medium">
            {{ t('leaderboardRules.subtitle') }}
          </div>

          <div>
            {{ t('leaderboardRules.period') }}
          </div>

          <div class="font-weight-bold mt-1">{{ t('leaderboardRules.conditionsTitle') }}</div>

          <div>
            <span class="font-weight-bold">{{ t('leaderboardRules.condition1Title') }}</span><br />
            {{ t('leaderboardRules.condition1Desc') }}
          </div>

          <div>
            <span class="font-weight-bold">{{ t('leaderboardRules.condition2Title') }}</span><br />
            {{ t('leaderboardRules.condition2Desc') }}
          </div>

          <div class="font-weight-bold mt-1">{{ t('leaderboardRules.selectionTitle') }}</div>
          <div>
            {{ t('leaderboardRules.selectionDesc') }}
          </div>

          <div class="font-weight-bold mt-1">{{ t('leaderboardRules.exampleTitle') }}</div>
          <div style="white-space: pre-line;">
            {{ t('leaderboardRules.exampleDesc') }}
          </div>

          <div class="font-weight-bold mt-1">{{ t('leaderboardRules.prizesTitle') }}</div>
          <div style="white-space: pre-line;">
            {{ t('leaderboardRules.prizesDesc') }}
          </div>
        </div>
      </v-card-text>

      <v-card-actions v-if="mobile" class="pa-0">
        <v-btn
          color="primary"
          variant="flat"
          block
          rounded="lg"
          @click="isVisible = false"
        >
          {{ t('leaderboardRules.understand') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.overflow-y-auto {
  overflow-y: auto;
}
</style>
